import React from 'react'
import { Table, Alert } from 'antd'
import { TableWrapper, TableMeta } from 'styles/styled-components'
import { AccountTransaction } from 'entities/AccountTransaction'
import AccountTxnsTableColumns from './AccountTxnsTableColumns'

interface Props {
  loading: boolean
  data: AccountTransaction[]
  errorMessage: string | null
  currentPage: number
  currentPageSize: number
  paginateChange: any
  pageSizeChange: any
  tableSize: any
}

const AccountTxnsTable: React.FC<Props> = ({
  loading,
  data,
  errorMessage,
  currentPage,
  currentPageSize,
  paginateChange,
  pageSizeChange,
  tableSize,
}) => {
  return (
    <TableWrapper>
      {!errorMessage && !loading && <TableMeta>Only the first 10,000 are displayed</TableMeta>}
      {!errorMessage ? (
        <Table
          columns={AccountTxnsTableColumns}
          dataSource={data}
          loading={loading}
          bordered
          rowKey={(record) => record.key}
          size={tableSize}
          pagination={{
            position: ['topRight', 'bottomRight'],
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            total: data.length,
            current: currentPage,
            onChange: (page, pageSize) => paginateChange(page, pageSize),
            onShowSizeChange: (current, size) => pageSizeChange(current, size),
            defaultPageSize: 200,
            pageSize: currentPageSize,
          }}
        />
      ) : (
        <Alert style={{ margin: '30px 8px' }} message={errorMessage} type="error" />
      )}
    </TableWrapper>
  )
}

export default AccountTxnsTable
